import { isValidCssHexColor } from '@/resultlist/layoutSolutionRequest';
import type { LayoutSolutionRequest } from '@/types';
import { watch, type Ref } from 'vue';

const THEME_STYLE_ID = 'theme-style';

export function useThemeStyle(layoutSolutionRequest: Ref<LayoutSolutionRequest | undefined>) {
  // Create/update style element for teleported modals
  const updateModalTheme = (request: LayoutSolutionRequest | undefined) => {
    const { primaryColor, primaryTextColor } = request || {};

    // Only apply if colors are valid
    const validPrimaryColor = isValidCssHexColor(primaryColor);
    const validPrimaryTextColor = isValidCssHexColor(primaryTextColor);

    if (validPrimaryColor || validPrimaryTextColor) {
      let style = document.getElementById(THEME_STYLE_ID);
      if (!style) {
        style = document.createElement('style');
        style.id = THEME_STYLE_ID;
        document.head.appendChild(style);
      }

      style.textContent = `[data-test="searchBarModal"] {
        ${validPrimaryColor ? `--theme-color-primary: #${primaryColor}; --theme-color-primary-hover: #${primaryColor}; --theme-color-primary-active: #${primaryColor};` : ''}
        ${validPrimaryTextColor ? `--theme-color-primary-text: #${primaryTextColor}; --theme-color-text-fill: #${primaryTextColor};` : ''}
      }`;
    }
  };

  // Watch for changes and apply immediately
  watch(layoutSolutionRequest, updateModalTheme, { immediate: true });

  // Cleanup function
  const cleanup = () => {
    if (typeof document !== 'undefined') {
      const styleEl = document.getElementById(THEME_STYLE_ID);
      if (styleEl) {
        styleEl.remove();
      }
    }
  };

  return {
    cleanup,
  };
}
